'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ClientsGroupNewCtrl
 * @description
 * # ClientNewCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('ClientsGroupNewCtrl', [
    '$scope', '$rootScope', 'ClientsGroup', '$state', '$stateParams', 'toaster', function ($scope, $rootScope, ClientsGroup, $state, $stateParams, toaster) {

    if($stateParams.clientGroupId) {
      ClientsGroup.find($stateParams.clientGroupId).then(function(response) {
        const client_group = response.data.client_group;
        $scope.clientGroupHash = { 'client_group': client_group };
      }, function(error) {
        ClientsGroup.error(error);
      });
    } else {
      $scope.clientGroupHash = {
        'client_group': {
          'name': '',
        }
      };
    }

    $scope.saveclientGroup= function() {
      ClientsGroup.save($scope.clientGroupHash).then((response) => {
        $scope.clientGroupHash = {
          'client_group': {
            'name': '',
          }
        };
        toaster.pop('success', 'Grupo de Cliente', 'Se creo o se edito correctamente el Grupo de Clientes');
        $state.go('app.client_group.list', {clientGroupId: response.data.id});
      }).catch((error) => {
        ClientsGroup.error(error);
      });
    };
    }]);
